module.exports = __webpack_public_path__ + "static/media/arrow-azul.7820125b.svg";